import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { format } from 'date-fns'

import { useViewport } from '@chilecompra/react-kit'
import { Card, Typography } from '@chilecompra/react-kit/components'

import QuoteListPurchaseOrderTable from './QuoteListPurchaseOrder.table'
import QuoteListPurchaseOrderDisclaimer from './QuoteListPurchaseOrder.disclaimer'

import { useAuthorization } from '../../containers/AuthorizationProvider/AuthorizationProvider.hooks'

import { PURCHASE_ORDER_STATUS_DICTIONARY, QUOTE_STATUSES_DICTIONARY } from '../../config/settings/constants'

import { Grid } from './QuoteListPurchaseOrder.styles'

const isHiddenStatusBySeller = status =>
  status === PURCHASE_ORDER_STATUS_DICTIONARY.SAVED ||
  status === PURCHASE_ORDER_STATUS_DICTIONARY.SEND_BY_ALLOW ||
  status === PURCHASE_ORDER_STATUS_DICTIONARY.ALLOW

/**
 * The Quote List Purchase Order's container.
 */
const QuoteListPurchaseOrderContainer = () => {
  const { size } = useViewport()
  const { isSeller } = useAuthorization()

  const { basicInfo, loading, bidding } = useSelector(state => state.quoteBasicInformation)

  const purchaseOrders = useMemo(() => {
    const biddings = bidding || {}
    return Object.values(biddings).flatMap(item => item.purchaseOrder || [])
  }, [bidding])

  const listPurchaseOrder = useMemo(
    () =>
      purchaseOrders.map(item => ({
        amount: item.amount ?? 'Sin información',
        code: item.code,
        date: item.date ? format(new Date(item.date), 'dd-MM-yyyy') : 'Sin información',
        idStatus: item.idState,
        isActive: item.isActive,
        status: item.text,
        supplierDni: item.supplierDni ?? 'Sin información',
        supplierLegalName: item.supplierLegalName ?? 'Sin información'
      })),
    [purchaseOrders]
  )

  const areAllStatesHiddenBySeller = useMemo(
    () => purchaseOrders.length > 0 && isSeller && purchaseOrders.every(order => isHiddenStatusBySeller(order.idState)),
    [purchaseOrders, isSeller]
  )

  const shouldShowPurchaseOrders =
    [
      QUOTE_STATUSES_DICTIONARY.CLOSED,
      QUOTE_STATUSES_DICTIONARY['Proveedor seleccionado'],
      QUOTE_STATUSES_DICTIONARY.CANCELLED,
      QUOTE_STATUSES_DICTIONARY.DESERTED
    ].includes(basicInfo?.statusId) && listPurchaseOrder.length > 0

  if (!shouldShowPurchaseOrders) return null

  return (
    <>
      <Grid container padding={size.isDownToTiny ? '8px 0 0' : '41px 0 0'}>
        <Grid item xs={12}>
          <Typography color="black1" fontSize="22px" fontWeight="bold" lineHeight="26px" variant="h3">
            Órdenes de compra emitidas
          </Typography>
        </Grid>
        <Grid container padding={size.isDownToTiny ? '8px 0' : '20px 0 0'}>
          <Grid item xs={12}>
            <Card enableBorder color="blank" margin="4px 0 0">
              {!areAllStatesHiddenBySeller && (
                <QuoteListPurchaseOrderTable purchaseOrders={listPurchaseOrder} loading={loading} />
              )}
              {areAllStatesHiddenBySeller && <QuoteListPurchaseOrderDisclaimer />}
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default QuoteListPurchaseOrderContainer
